// extracted by mini-css-extract-plugin
export default {"timer":"n0-z","loaded":"o0-z"};